import { faTimes, faGlobe, faAt, faPhone, faList, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { groups, deptEnglishNames } from "./groups";
import "./ProfileCard.css";

export function ProfileCard(props) {

    const mtmtLink = "https://m2.mtmt.hu/api/author/"+props.person["MTMT"]+(props.lang === "en" ? "?&labelLang=eng" : "");

    let picLink = "./data/unknown.png";
    if (props?.person?.["Fotó"])
        picLink = props.person["Fotó"][0] === "." ? props.person["Fotó"] : `./data/${props.person['Fotó']}`;

    return <div className="profile-card-main" style={{left: `min(${props.left}px, 100vw - 23em)`, top: `min(${props.right}px, 100vh - 33em)`}}>
        <div className="background-top"/>
        <div className="close-button" onClick={() => props.onClick()}><FontAwesomeIcon icon={faTimes} size="lg"/></div>
        <div className="image-border"/>
        <img src={picLink} alt="👤"/>
        <div className="info-area">
            <div className="intro">
                <div className="name">{props.person.name || props.person["Név"]}</div>
                {props.lang === "hu" && props.person["Munkakör"] && <div className="position">{props.person["Munkakör"].toLowerCase()}</div>}
                {props.lang === "en" && props.person["Position"] && <div className="position">{props.person["Position"].toLowerCase()}</div>}
                {props.person["Tanszék"] && <div className="position">{props.lang==="hu" ? props.person["Tanszék"] : deptEnglishNames[props.person["Tanszék"]] }</div>}
            </div>
            {props.researchInfo && <div className="research-info">
                <h2>{props.lang === "hu" ? "Kutatócsoport:" : "Research group:"}</h2>
                 {props.researchInfo.groups.map((d, ix) => {
                    const grp = groups.find(g => g.hu === d || g.en === d);
                    if (grp)
                        return <div key={ix}><a href={"/#/groups/" + grp.id + (props.lang === "en" ? "?lang=en" : "")}>{grp[props.lang]}</a></div>;
                    else
                        return null;
                })}
            </div>}
            <div className="data">
                <FontAwesomeIcon icon={faAt} size="sm"/><div className="item"><a href={`mailto:${props.person["Email"]}`}>{props.person["Email"]}</a> </div>
                <FontAwesomeIcon icon={faPhone} size="sm"/><div className="item"><a href={`tel:${props.person["Telefonszám"]}`}>{props.person["Telefonszám"]}</a> </div>
                <FontAwesomeIcon icon={faMapMarkerAlt} size="sm"/><div className="item">{props.person["Szoba"]} </div>
                {props.person["MTMT"] && props.person["MTMT"].length > 0 && <><FontAwesomeIcon icon={faList} size="sm"/><div className="item"><a href={mtmtLink} rel="noreferrer" target="_blank">{props.lang === "hu" ? "Publikációs lista" : "Publication list"}</a></div></>}
            </div>
            <div className="button-panel">
                <a href={props.person["Web"]} rel="noreferrer" target="_blank"><div title={props.lang === "hu" ? "Weblap" : "Web page"}><FontAwesomeIcon icon={faGlobe} size="lg"/></div></a>
                <a href={"mailto:"+props.person["Email"]} rel="noreferrer" target="_blank"><div title="E-mail"><FontAwesomeIcon icon={faAt} size="lg"/></div></a>
                <a href={"tel:"+props.person["Telefonszám"]} rel="noreferrer" target="_blank"><div title={props.lang === "hu" ? "Telefon" : "Phone"}><FontAwesomeIcon icon={faPhone} size="lg"/></div></a>
                {props.person["MTMT"] && props.person["MTMT"].length > 0 && <a href={mtmtLink} rel="noreferrer" target="_blank"><div title={props.lang === "hu" ? "Publikációk" : "Publications"}><FontAwesomeIcon icon={faList} size="lg"/></div></a>}
            </div>
        </div>
    </div>;
}


export function DetailedCard(props) {

    let picLink = "./data/unknown.png";
    if (props?.person?.["Fotó"])
        picLink = props.person["Fotó"][0] === "." ? props.person["Fotó"] : `./data/${props.person['Fotó']}`;    

    return <div className="detailed-person-card-main" onClick={evt => props.onClick(props.person, evt.clientX, evt.clientY)}>
        <div className="detailed-person-card-img-container">
            <img src={picLink} alt="👤"/>
        </div>
        <div className="detailed-person-card-data-container">
            <div className="detailed-person-card-item">{props.person.name}</div>
            {props.lang === "hu" && props.person["Munkakör"]    && <div className="detailed-person-card-item">{props.person["Munkakör"].toLowerCase()}</div>}
            {props.lang === "en" && props.person["Position"]    && <div className="detailed-person-card-item">{props.person["Position"].toLowerCase()}</div>}
            {props.person["Szoba"]       && <div className="detailed-person-card-item">{props.person["Szoba"]}</div>}
            {props.person["Telefonszám"] && <div className="detailed-person-card-item">{props.person["Telefonszám"]}</div>}
            {props.person["Email"]       && <div className="detailed-person-card-item"><a href={`mailto:${props.person["Email"]}`}>{props.person["Email"]}</a> </div>}
        </div>
    </div>;
}

export function BasicCard(props) {

    let picLink = "./data/unknown.png";
    if (props?.person?.["Fotó"])
        picLink = props.person["Fotó"][0] === "." ? props.person["Fotó"] : `./data/${props.person['Fotó']}`;
    
    return <div className="basic-person-card-main" onClick={evt => props.onClick(props.person, evt.clientX, evt.clientY)}>
        <div className="basic-person-card-img-container">
            <img src={picLink} alt="👤"/>
        </div>
        <div className="basic-person-card-data-container">
            <div className="basic-person-card-item">{props.person.name}</div>
            {props.person["Munkakör"] && <div className="basic-person-card-item">{props.person[props.lang === "hu" ? "Munkakör" : "Position"].toLowerCase()}</div>}
        </div>
    </div>;
}
